import { Reducer } from "redux";
import { IPagination } from "..";
import { PaginationAction, PaginationActionType } from "../actions";

export const PaginationReducer: Reducer<IPagination> = (state: IPagination = { page: 1, hasPreviousPage: false, hasNextPage: false}, action: PaginationAction) => {
    switch (action.type) {
        case PaginationActionType.UPDATE:
            if(action.pagination) {
                return {
                    page: action.pagination.page,
                    hasNextPage: action.pagination.hasNextPage,
                    hasPreviousPage: action.pagination.hasPreviousPage
                }
            }
        default:
            return state;
    }
}